export const GET_ORDERS_OFFICE = "GET_ORDERS_OFFICE"
export const GET_ORDERS_OFFICE_SUCCESS = "GET_ORDERS_OFFICE_SUCCESS"
export const GET_ORDERS_OFFICE_FAILED = "GET_ORDERS_OFFICE_FAILED"

export const GET_ORDERS = "GET_ORDERS"
export const GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS"
export const GET_ORDERS_FAILED = "GET_ORDERS_FAILED"

export const GET_ORDER_RESTART = "GET_ORDER_RESTART"
export const GET_ORDER = "GET_ORDER"
export const GET_ORDER_SUCCESS = "GET_ORDER_SUCCESS"
export const GET_ORDER_FAILED = "GET_ORDER_FAILED"

export const REGISTER_ORDER = "REGISTER_ORDER"
export const REGISTER_ORDER_SUCCESS = "REGISTER_ORDER_SUCCESS"
export const REGISTER_ORDER_FAILED = "REGISTER_ORDER_FAILED"

export const NEXT_STATUS_ORDER = "NEXT_STATUS_ORDER"
export const RESUME_ORDER = "RESUME_ORDER"
export const PRINT_ORDER = "PRINT_ORDER"
export const CANCELED_STATUS_ORDER = "CANCELED_STATUS_ORDER"

export const GET_HISTORIC_ORDER = "GET_HISTORIC_ORDER"
export const GET_HISTORIC_ORDER_SUCCESS = "GET_HISTORIC_ORDER_SUCCESS"
export const GET_HISTORIC_ORDER_FAILED = "GET_HISTORIC_ORDER_FAILED"

export const CUSTOM_ORDER_SUCCESS = "CUSTOM_ORDER_SUCCESS"
export const CUSTOM_ORDER_FAILED = "CUSTOM_ORDER_FAILED"

export const UPDATE_ORDER = "UPDATE_ORDER"
export const UPDATE_ORDER_SUCCESS = "UPDATE_ORDER_SUCCESS"
export const UPDATE_ORDER_FAILED = "UPDATE_ORDER_FAILED"

export const UPDATE_ORDER_PRODUCTS = "UPDATE_ORDER_PRODUCTS"
export const UPDATE_ORDER_PRODUCTS_SUCCESS = "UPDATE_ORDER_PRODUCTS_SUCCESS"
export const UPDATE_ORDER_PRODUCTS_FAILED = "UPDATE_ORDER_PRODUCTS_FAILED"

export const GET_DELIVERY_METHODS = "GET_DELIVERY_METHODS"
export const GET_DELIVERY_METHODS_SUCCESS = "GET_DELIVERY_METHODS_SUCCESS"
export const GET_DELIVERY_METHODS_FAILED = "GET_DELIVERY_METHODS_FAILED"

export const GET_DELIVERY_QUOTE = "GET_DELIVERY_QUOTE"
export const GET_DELIVERY_QUOTE_SUCCESS = "GET_DELIVERY_QUOTE_SUCCESS"
export const GET_DELIVERY_QUOTE_FAILED = "GET_DELIVERY_QUOTE_FAILED"

export const RESET_CAR = "RESET_CAR"
export const UPDATE_CAR = "UPDATE_CAR"

export const PRINT_BATCH_REQUEST = "PRINT_BATCH_REQUEST"
export const PRINT_BATCH_REQUEST_SUCCESS = "PRINT_BATCH_REQUEST_SUCCESS"
export const PRINT_BATCH_REQUEST_FAILED = "PRINT_BATCH_REQUEST_FAILED"
export const DO_BATCH_REQUEST = "DO_BATCH_REQUEST"
export const RESET_BATCH_REQUEST = "RESET_BATCH_REQUEST"

export const REFRESH_ORDER = "REFRESH_ORDER"

export const CONCILIATION_REQUEST = "CONCILIATION_REQUEST"
export const CONCILIATION_SUCCESS = "CONCILIATION_SUCCESS"
export const CONCILIATION_FAILED = "CONCILIATION_FAILED"

export const CONFIRM_CONCILIATION_REQUEST = "CONFIRM_CONCILIATION_REQUEST"
export const CONFIRM_CONCILIATION_SUCCESS = "CONFIRM_CONCILIATION_SUCCESS"
export const CONFIRM_CONCILIATION_FAILED = "CONFIRM_CONCILIATION_FAILED"
export const CONFIRM_CONCILIATION_RESTART = "CONFIRM_CONCILIATION_RESTART"

export const RESET_ORDER = "RESET_ORDER";

export const SYNC_DELIVERY_ORDER = "SYNC_DELIVERY_ORDER"
export const SYNC_DELIVERY_ORDER_SUCCESS = "SYNC_DELIVERY_ORDER_SUCCESS"
export const SYNC_DELIVERY_ORDER_FAILED = "SYNC_DELIVERY_ORDER_FAILED"

export const REFRESH_DELIVERY_ORDER = "REFRESH_DELIVERY_ORDER"
export const REFRESH_DELIVERY_ORDER_SUCCESS = "REFRESH_DELIVERY_ORDER_SUCCESS"
export const REFRESH_DELIVERY_ORDER_FAILED = "REFRESH_DELIVERY_ORDER_FAILED"

export const DOWNLOAD_PHOTO = "DOWNLOAD_PHOTO"
export const DOWNLOAD_PHOTO_SUCCESS = "DOWNLOAD_PHOTO_SUCCESS"
export const DOWNLOAD_PHOTO_FAILED = "DOWNLOAD_PHOTO_FAILED"
export const CLEAN_ERROR_MESSAGE = "CLEAN_ERROR_MESSAGE"

export const GET_LINK_PAYMENT = "GET_LINK_PAYMENT"
export const GET_LINK_PAYMENT_SUCCESS = "GET_LINK_PAYMENT_SUCCESS"
export const GET_LINK_PAYMENT_FAILED = "GET_LINK_PAYMENT_FAILED"
